import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Behfa_Interface } from 'src/app/Interface/Behfa_Interface';

import { HelpService } from 'src/app/Service/Help/Help.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-HelpView',
  templateUrl: './HelpView.component.html',
  styleUrls: ['./HelpView.component.scss']
})
export class HelpViewComponent implements OnInit {

  Token:String=""
  BaseUrl=environment.BaseUrl
  @Input() DataList_Behfa:Array<Behfa_Interface>=[]
  @Output() OnBack_Help_Action = new EventEmitter<number>();

  constructor(
    private Help_Service:HelpService,
  ) { }



  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');

  }



  OnSet_Back_HelpList(){
    this.OnBack_Help_Action.emit(-1);
  }


}
